export default function RevenueModel() {
  const revenueStreams = [
    {
      icon: 'ri-video-chat-line',
      label: 'Teleconsults',
      amount: '$75–$125/consult',
      color: 'from-[#4DB8D4] to-[#2a9ab8]',
    },
    {
      icon: 'ri-vip-crown-line',
      label: 'Memberships',
      amount: '$25/month',
      color: 'from-[#0F1F3D] to-[#1a3a6e]',
    },
    {
      icon: 'ri-shopping-bag-3-line',
      label: 'Curated Products',
      amount: '25%–40% margins',
      color: 'from-[#4DB8D4] to-[#2a9ab8]',
    },
    {
      icon: 'ri-heart-pulse-line',
      label: 'Subscription Care Plans',
      amount: '$25/month',
      color: 'from-[#0F1F3D] to-[#1a3a6e]',
    },
    {
      icon: 'ri-heart-pulse-line',
      label: 'Follow-Up Care',
      amount: '$45/session',
      color: 'from-[#4DB8D4] to-[#3aa8c4]',
    },
  ];

  return (
    <section id="revenue" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="bg-[#0F1F3D] rounded-3xl p-12 lg:p-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Side */}
            <div className="space-y-6">
              <span className="text-xs font-semibold tracking-widest uppercase text-[#4DB8D4]">
                Revenue Model
              </span>
              <h2 className="text-4xl lg:text-5xl font-serif text-white leading-tight">
                Multiple Income Streams, One Platform
              </h2>
              <p className="text-lg text-[#A8C8D8] leading-relaxed">
                Vetuvia is the infrastructure layer for your veterinary career. Build recurring revenue through teleconsults, wellness memberships, follow-up care packages, curated product sales, and digital resources. Choose what works for your expertise and schedule.
              </p>
              <button className="mt-6 px-8 py-4 bg-white text-[#0F1F3D] font-medium rounded-full hover:bg-gray-100 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer group">
                Explore Revenue Options
                <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
              </button>
            </div>

            {/* Right Side - Revenue Cards */}
            <div className="grid grid-cols-2 gap-4">
              {revenueStreams.slice(0, 4).map((stream, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl p-6 hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer"
                >
                  <div className={`w-12 h-12 bg-gradient-to-br ${stream.color} rounded-lg flex items-center justify-center mb-4`}>
                    <i className={`${stream.icon} text-white text-xl`}></i>
                  </div>
                  <h4 className="text-sm font-semibold text-gray-900 mb-2">{stream.label}</h4>
                  <p className="text-lg font-bold text-[#4DB8D4]">{stream.amount}</p>
                </div>
              ))}
              <div className="col-span-2 bg-white rounded-xl p-6 hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer">
                <div className={`w-12 h-12 bg-gradient-to-br ${revenueStreams[4].color} rounded-lg flex items-center justify-center mb-4`}>
                  <i className={`${revenueStreams[4].icon} text-white text-xl`}></i>
                </div>
                <h4 className="text-sm font-semibold text-gray-900 mb-2">{revenueStreams[4].label}</h4>
                <p className="text-lg font-bold text-[#4DB8D4]">{revenueStreams[4].amount}</p>
              </div>
            </div>
          </div>

          {/* Methodology disclaimer */}
          <div className="mt-8 pt-6 border-t border-white/10">
            <p className="text-xs text-[#7DCFE8] italic text-center">
              Rates reflect platform pricing range; actual earnings depend on session volume and service mix.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}